module.exports = __webpack_public_path__ + "img/aifxjz-1-sm.124d91ce.jpg";